import { useCallback, useEffect, useRef, useState } from 'react'
import { Link } from '@chakra-ui/react'

import { useGetPlayerById } from '@hooks/useGetPlayerByIDSearch'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

export function PlayerDetailLink() {
    const { newPlayer, isFakePlayer, isFrontFakePlayer } = useAddPlayerContext()
    const [playerDetailUrl, setPlayerDetailUrl] = useState<string | null>(newPlayer.playerDetailUrl ?? null)
    const { getPlayerById } = useGetPlayerById()
    const patchingPlayerDetailUrl = useRef<string | null>(null)

    const patchPlayerDetailUrl = useCallback(
        async (playerId: string) => {
            if (isFakePlayer || isFrontFakePlayer || patchingPlayerDetailUrl.current === playerId) {
                return
            }

            patchingPlayerDetailUrl.current = playerId

            const playerDetails = await getPlayerById(playerId)

            if (playerDetails?.playerDetailUrl) {
                setPlayerDetailUrl(playerDetails.playerDetailUrl)
            }
        },
        [getPlayerById, isFakePlayer, isFrontFakePlayer],
    )

    useEffect(() => {
        setPlayerDetailUrl(newPlayer?.playerDetailUrl ?? null)
    }, [newPlayer?.playerDetailUrl])

    useEffect(() => {
        if (newPlayer?.id && !newPlayer?.playerDetailUrl) {
            patchPlayerDetailUrl(newPlayer.id)
        }
    }, [newPlayer?.id, newPlayer?.playerDetailUrl, patchPlayerDetailUrl])

    if (isFakePlayer || isFrontFakePlayer || !playerDetailUrl) {
        return null
    }

    return (
        <Link fontSize="xs" fontWeight="bold" color="blue.500" href={playerDetailUrl} target="_blank">
            View on Superscore
        </Link>
    )
}
